let state_code_data = [
  { 'AN': '35' },
  { 'AP': '37' },
  { 'AR': '12' },
  { 'AS': '18' },
  { 'BR': '10' },
  { 'CH': '04' },
  { 'DN': '26' }, // updated from 'DH'
  { 'DL': '07' },
  { 'GA': '30' },
  { 'GJ': '24' },
  { 'HR': '06' },
  { 'HP': '02' },
  { 'JK': '01' },
  { 'JH': '20' },
  { 'KA': '29' },
  { 'KL': '32' },
  { 'LA': '38' }, // corrected from '01'
  { 'LD': '31' },
  { 'MP': '23' },
  { 'MH': '27' },
  { 'MN': '14' },
  { 'ML': '17' },
  { 'MZ': '15' },
  { 'NL': '13' },
  { 'OD': '21' }, // optional: OR → OD
  { 'PY': '34' },
  { 'PB': '03' },
  { 'RJ': '08' },
  { 'SK': '11' },
  { 'TN': '33' },
  { 'TG': '36' },
  { 'TR': '16' },
  { 'UT': '05' },
  { 'UP': '09' },
  { 'WB': '19' },
  { 'CT': '22' }
];

export { state_code_data };


